import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from 'axios';
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {
  required,
  decimal,
} from "vuelidate/lib/validators";

export default {
  name: "skillCreate",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    Loading,
  },

  data() {
    return {
      empData: {
        employeeType: "1",
        employeeId: null,
        empNumber: '',
        positionId: null,
        startDate: '',
        basicSalary: '0.00',
        totalSalary: '0.00',
        salaryComponents: [],
        basicSalaryAttrId: null,
        employmentType: CONFIG.EMPLOYMENT_TYPE.FULL_TIME,
      },
      employeeList: [],
      employeeOptions: [],
      positionOptions: [],
      submitted: false,
      disabled: false,
      isLoading: true,
      CONFIG,
    };
  },

  validations() {
    const rules = {
      employeeType: { required },
      employeeId: { required },
      positionId: { required },
      startDate: { required },
      basicSalary: {
        required,
        decimal,
        maxDigits: (value) => !value || /^\d{1,8}(\.\d{1,2})?$/.test(value),
        twoDecimal: (value) => !value || /^\d+(\.\d{1,2})?$/.test(value),
      },
    };
    if (this.isFullTimeEmployee) {
      rules.salaryComponents = {
        $each: {
          amount: {
            decimal,
            maxDigits: (value) => !value || /^\d{1,8}(\.\d{1,2})?$/.test(value),
            twoDecimal: (value) => !value || /^\d+(\.\d{1,2})?$/.test(value),
          }
        },
      };
    }
    return { empData: rules };
  },

  computed: {
    isFullTimeEmployee() {
      return this.empData.employmentType == CONFIG.EMPLOYMENT_TYPE.FULL_TIME;
    },
    isBasicSalaryEditable() {
      return this.empData.employmentType == CONFIG.EMPLOYMENT_TYPE.DAILY_PART_TIME
        || this.empData.employmentType == CONFIG.EMPLOYMENT_TYPE.HOURLY_PART_TIME;
    },
    basicSalaryLabel() {
      if (this.empData.employmentType == CONFIG.EMPLOYMENT_TYPE.DAILY_PART_TIME) {
        return 'Daily Rate';
      }
      if (this.empData.employmentType == CONFIG.EMPLOYMENT_TYPE.HOURLY_PART_TIME) {
        return 'Hourly Rate';
      }
      return 'Basic Salary';
    },
  },

  watch: {
    'empData.employeeType': function (newType) {
      this.isLoading = true;
      this.getEmployees(newType).finally(() => {
        this.isLoading = false;
      });

      this.empData.employeeId = null;
      this.empData.empNumber = '';
      this.empData.positionId = null;
      this.empData.employmentType = CONFIG.EMPLOYMENT_TYPE.FULL_TIME;
    },
    'empData.employeeId': function (newId) {
      const id = Array.isArray(newId) ? newId[0] : newId;

      if (id && id != 0) {
          const selected = this.employeeList.find(emp => emp.id == id);
          if (selected) {
              this.empData.empNumber = selected.emp_no;
              this.empData.positionId = selected.position_id;
              this.empData.employmentType = selected.employment_type || CONFIG.EMPLOYMENT_TYPE.FULL_TIME;
              this.empData.startDate = selected.start_date || '';
              this.empData.basicSalary = (selected.basic_salary_info && selected.basic_salary_info.amount)
                                          ? parseFloat(selected.basic_salary_info.amount).toFixed(2)
                                          : "0.00";

              this.empData.salaryComponents.forEach(component => {
                const existingSkill = selected.salary_components
                                      ? selected.salary_components.find(s => s.id === component.id)
                                      : null;
                component.amount = (existingSkill && existingSkill.amount) ? existingSkill.amount : "0.00";
              });

              this.calculateTotal();
          }
      } else {
        this.empData.empNumber = '';
        this.empData.positionId = null;
        this.empData.employmentType = CONFIG.EMPLOYMENT_TYPE.FULL_TIME;
        this.empData.startDate = '';
        this.empData.basicSalary = '0.00';
        this.empData.totalSalary = '0.00';
        if (Array.isArray(this.empData.salaryComponents)) {
          this.empData.salaryComponents.forEach(component => {
            component.amount = "0.00";
          });
        }
      }
    },

    'empData.positionId': function (newPosId) {
      if (!newPosId || (Array.isArray(newPosId) && newPosId.length === 0)) {
        this.empData.basicSalary = "0.00";
        this.calculateTotal();
        return;
      }
      const targetId = Array.isArray(newPosId) ? newPosId[0] : newPosId;
      const selectedPos = this.positionOptions.find(pos => pos.id == targetId);

      if (selectedPos) {
        this.empData.basicSalary = this.resolvePositionBasicSalary(selectedPos, this.empData.employmentType);
        this.calculateTotal();
      } else {
        this.empData.basicSalary = "0.00";
        this.calculateTotal();
      }
    },
  },
  methods: {
    getEmployees(type = null) {
      const fetchType = type || this.empData.employeeType;
      return axios.get('/skill/get-employee', {
        params: { 
          employee_type: fetchType,
        }
      }) .then(res => {
        this.employeeList = res.data;
        this.employeeOptions = res.data.map(emp => ({
          id: emp.id,
          text: `${emp.emp_no || ''} - ${emp.name}`.trim()
        }));
      }).catch(error => {
        console.error("Error fetching employees", error);
      });
    },
  
    getPositions() {
      return axios.get('position/all')
      .then(res => {
        this.positionOptions = res.data.map(pos => ({
          id: pos.id,
          text: pos.position_name,
          basic_salary: pos.basic_salary,
          daily_salary: pos.daily_salary,
          hourly_salary: pos.hourly_salary,
        }));
      }) .catch(error => {
        console.error("Error fetching positions", error);
      });
    },

    resolvePositionBasicSalary(position, employmentType) {
      if (employmentType == CONFIG.EMPLOYMENT_TYPE.DAILY_PART_TIME) {
        return position.daily_salary ? parseFloat(position.daily_salary).toFixed(2) : '0.00';
      }
      if (employmentType == CONFIG.EMPLOYMENT_TYPE.HOURLY_PART_TIME) {
        return position.hourly_salary ? parseFloat(position.hourly_salary).toFixed(2) : '0.00';
      }
      return position.basic_salary ? parseFloat(position.basic_salary).toFixed(2) : '0.00';
    },

    calculateTotal() {
      const base = parseFloat(this.empData.basicSalary) || 0;
      const components = this.empData.salaryComponents.reduce((sum, item) => {
        return sum + (parseFloat(item.amount) || 0);
      }, 0);
      this.empData.totalSalary = (base + components).toFixed(2); 
    },

    getSkillAttributes() {
      return axios.get('/paymentAttribute/skill-attributes')
        .then(res => {
          this.empData.salaryComponents = res.data.components.map(c => ({
              ...c,
              amount: "0.00"
          }));
          if (res.data.basic_salary_attr_id) {
            this.empData.basicSalaryAttrId = res.data.basic_salary_attr_id;
          }
        });
    },

    async fetchInitialData() {
      this.isLoading = true;
      try {
        await Promise.all([
          this.getEmployees(),
          this.getPositions(),
          this.getSkillAttributes()
        ]);
      } catch (error) {
        console.error(error);
      }
    },

    async create() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }

      if (!this.empData.basicSalaryAttrId) {
        this.$notification.error("Basic Salary payment attribute is missing. Please create a Skill attribute with type Basic Salary (FVB) first.", {
          timer: 5,
          position: "bottomCenter"
        });
        return;
      }

      this.isLoading = true;
      this.disabled = true;
      const cleanId = (id) => {
        if (Array.isArray(id)) return id[0];
        return id;
      };
      const payload = {
        employeeable_id: parseInt(cleanId(this.empData.employeeId)), 
        employee_type: String(this.empData.employeeType),
        position_id: parseInt(cleanId(this.empData.positionId)), 
        start_date: this.empData.startDate,
        basic_salary: parseFloat(this.empData.basicSalary) || 0,
        basic_salary_attr_id: this.empData.basicSalaryAttrId,
        skills: this.empData.salaryComponents.map(skill => ({
          attribute_id: parseInt(skill.id),
          amount: skill.amount === "" ? 0 : parseFloat(skill.amount)
        })),
      };

      try {
        this.isLoading = true;
        this.disabled = true;
        const response = await axios.post('/skill/store', payload);
        if (response.status === 200 || response.status === 201) {
          this.$notification.success("Skill Data Registered Successfully", {
            timer: 3,
            position: "bottomCenter"
          });
          this.$router.push({
            name: 'skillList'
          })
        }
      } catch (error) {
        console.error("Failed to create skill data:", error);
      } finally {
        this.disabled = false;
      }
    }
  },

  async mounted() {
    this.isLoading = true;
    try {
      await this.fetchInitialData();
    } finally {
      this.isLoading = false; 
    }
  }
};
